'use client'
import React, { useState, useEffect } from 'react'
import { ArrowLeftIcon, PhoneIcon } from '@heroicons/react/20/solid'
import NextLink from 'next/link'
import Image from 'next/image'
import _ from 'lodash'
import girl from '@/images/suitable-tutors/girl.png'
import { useRouter } from 'next/navigation'
import Pagination from '@/components/page-partials/common/pagination/index'
import answersSelector from '@/redux/selectors/answer'
import { useSelector } from 'react-redux'
import { getRegisteredTutors } from '@/firebase/tutor'
import tutorSelector from '@/redux/selectors/tutor'
import dummyProfilePic from '@/images/one-to-one/placeholder-img.png'
import Modal from '@/components/ui/modal'
import CommonSignUpForm from '@/components/ui/common-form-signup'
import SignInForm from '@/components/ui/form-signin'
import authSelector from '@/redux/selectors/auth'
import ImageLoader from '@/utils/imageLoader'
import CustomButton from '@/components/ui/custom-button'
import RequestCallback from '@/components/page-partials/tutors/tutor-details/Model/requestCallback'
import { getShortName } from '@/utils/index'
import SvgSpinnerBlue from '@/components/icons/spinner-blue'

const initialVal = {
  gender: 'All Gender',
  experience: 'All Experience',
  personality: 'All Personality',
  prices: 'All Prices',
}
export default function SuitableContent() {
  const [openFilter, setOpenFilter] = useState(false)
  const router = useRouter()
  const [activePage, setActivePage] = useState({ selected: 0 })
  const { user } = useSelector(authSelector)
  const [pageData, setPageData] = useState(null)
  const [currentItems, setCurrentItems] = useState(null)
  const [requstToSupport, setRequestToSupport] = useState(false)
  const [pageCount, setPageCount] = useState(0)
  const [itemOffset, setItemOffset] = useState(0)
  const [searchData, setSearchData] = useState([])
  const [tutorsWithRateList, setTutorsWithRateList] = useState([])
  const [bookModal, setBookModal] = useState(false)
  const [signin, setSignin] = useState(false)
  const [filter, setFilter] = useState(initialVal)

  const anwsers = useSelector(answersSelector)
  const tutor = useSelector(tutorSelector)
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [selectedVideo, setSelectedVideo] = useState({
    isYT: false,
    videoLink: '',
  })
  useEffect(() => {
    if (user && user.role == 'student') {
      router.replace('/student/one-to-one')
    } else if (user && user?.role == 'tutor') {
      router.push('/tutors-dashboard')
    } else if (user && user?.role == 'admin') {
      router.push('/admin')
    } else if (user && user?.role == 'parent') {
      router.push('/parent')
    }
  }, [user])

  const openModal = (videoLink, isYT) => {
    setSelectedVideo({ isYT: isYT, videoLink: videoLink })
    setModalIsOpen(true)
  }

  const closeModal = () => {
    setModalIsOpen(false)
    setSelectedVideo({ isYT: false, videoLink: '' })
  }
  const itemsPerPage = 5
  const handleBack = () => {
    router.back()
  }

  const getTutors = async () => {
    const order = 'asc'
    await getRegisteredTutors(null, order, 'approved', false, anwsers?.tutor)
  }

  useEffect(() => {
    getTutors()
  }, [])

  useEffect(() => {
    const tutorsWithRateSet = tutor.registeredTutors?.filter(
      (item) =>
        item?.tutorRate != null &&
        item?.availableDays?.length > 0 &&
        item?.availableHours?.length > 0 &&
        item?.visibility,
    )

    setPageData(tutorsWithRateSet)
    setSearchData(tutorsWithRateSet)
    setTutorsWithRateList(tutorsWithRateSet)
  }, [tutor.registeredTutors])

  useEffect(() => {
    // Fetch pageData from another resources.
    const endOffset = itemOffset + itemsPerPage
    setCurrentItems(pageData?.slice(itemOffset, endOffset))
    setPageCount(Math.ceil(pageData?.length / itemsPerPage))
  }, [itemOffset, itemsPerPage, pageData])

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % pageData?.length
    setItemOffset(newOffset)
  }
  const handleChange = (e) => {
    if (e.target.value !== '' && e.target.name == 'search') {
      const filteredData = (tutorsWithRateList || []).filter((row) =>
        row?.name?.toLowerCase().includes(e.target.value.trim().toLowerCase()),
      )
      setPageData(filteredData)
      setSearchData(filteredData)
    }
    if (e.target.value === '' && e.target.name == 'search') {
      setPageData(tutorsWithRateList)
      setSearchData(tutorsWithRateList)
    }
    if (e.target.name == 'gender') {
      setFilter({ ...filter, gender: e.target.value })
    }
    if (e.target.name == 'experience') {
      setFilter({ ...filter, experience: e.target.value })
    }
    if (e.target.name == 'personality') {
      setFilter({ ...filter, personality: e.target.value })
    }
    if (e.target.name == 'prices') {
      setFilter({ ...filter, prices: e.target.value })
    }
  }

  const handleApply = () => {
    const data = []

    const filteredData = searchData.filter((row) =>
      filter?.gender !== 'All Gender'
        ? row?.gender?.includes(filter.gender)
        : pageData,
    )

    const filteredData1 = (filteredData || []).filter((row) =>
      filter?.experience !== 'All Experience'
        ? row?.experiences?.includes(filter.experience)
        : filteredData,
    )
    filter.personality !== 'All Personality'
      ? filteredData1?.map((value) => {
          if (value?.personality?.includes(filter.personality)) {
            data.push(value)
          }
        })
      : filteredData1?.map((value) => {
          data.push(value)
        })
    if (filter.prices == '£10-£20') {
      const prices = []
      data?.map((value) => {
        if (
          10 <= value?.tutorRate?.perHourRate &&
          value?.tutorRate?.perHourRate < 21
        ) {
          prices.push(value)
        }
      })
      setPageData(prices)
    }
    if (filter.prices == '£20-£30') {
      const prices = []
      data?.map((value) => {
        if (
          20 <= value?.tutorRate?.perHourRate &&
          value?.tutorRate?.perHourRate < 31
        ) {
          prices.push(value)
        }
      })
      setPageData(prices)
    }
    if (filter.prices == '£30-£40') {
      const prices = []
      data?.map((value) => {
        if (
          30 <= value?.tutorRate?.perHourRate &&
          value?.tutorRate?.perHourRate < 41
        ) {
          prices.push(value)
        }
      })
      setPageData(prices)
    }
    if (filter.prices == '£40-£50') {
      const prices = []
      data?.map((value) => {
        if (
          40 <= value?.tutorRate?.perHourRate &&
          value?.tutorRate?.perHourRate < 51
        ) {
          prices.push(value)
        }
      })
      setPageData(prices)
    }
    if (filter.prices == '£50-£60') {
      const prices = []
      data?.map((value) => {
        if (
          50 <= value?.tutorRate?.perHourRate &&
          value?.tutorRate?.perHourRate < 61
        ) {
          prices.push(value)
        }
      })
      setPageData(prices)
    }
    if (filter.prices == 'All Prices') {
      setPageData(data)
    }
  }

  const isValidUrl = (string) => {
    try {
      new URL(string)
      return true
    } catch (err) {
      return false
    }
  }

  const isYTLink = (link) => {
    try {
      const Rlink = new URL(link)
      if (Rlink.host === 'www.youtube.com') {
        const videoid = Rlink.href.split('v=')[1].split('&')[0]
        return videoid
      } else return false
    } catch (err) {
      return false
    }
  }

  return (
    <>
      <div className="bg-tutor">
        <div className="sm:px-6  mx-auto max-w-7xl lg:px-8 py-[50px]">
          <button
            onClick={handleBack}
            className="text-[#A4BCFD]font-semibold text-base inline-flex space-x-1 items-center"
          >
            <ArrowLeftIcon className="h-5 w-5 flex-shrink-0 text-[#A4BCFD]" />
            <span className="text-[#A4BCFD]">Back</span>
          </button>

          <div className="flex items-center px-3 space-x-5 md:px-0">
            <div>
              <h1 className="py-2 text-3xl font-bold text-white">
                Suitable tutors
              </h1>
              <div className="sm:flex md:w-[80%] justify-between">
                <div className="self-center sm:w-[55%] ">
                  <p className="text-sm font-medium text-white">
                    We offer a range of tutoring services. Our experienced
                    tutors are available 24/7 to help with the challenging
                    material you are encountering.
                  </p>
                </div>
                <div className="flex self-center md:mt-0 mt-3 gap-2 max-w-[225px] pt-2">
                  <div className="self-center rounded-lg bg-v8-violet ">
                    <div className="flex p-2">
                      <div className="self-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="w-4 h-4 text-[#A4BCFD]"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                          />
                        </svg>
                      </div>
                      <div className="self-center">
                        <input
                          type="text"
                          className="text-[#A4BCFD] text-sm font-normal ml-2 bg-transparent border-none focus:ring-0"
                          placeholder="Search tutors"
                          name="search"
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="self-center bg-[#EEF4FF] rounded-[8px] p-[14px] cursor-pointer hover:bg-v8-blue/5 transition duration-300"
                    onClick={() => setOpenFilter(!openFilter)}
                  >
                    <div className="flex cursor-pointer">
                      <div className="self-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="w-4 h-4 text-v8-blue"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"
                          />
                        </svg>
                      </div>
                      <div className="self-center ml-2">
                        <p className="text-sm font-semibold text-v8-blue">
                          Filter
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 w-[80%]">
            {openFilter && (
              <div className="mt-5 lg:grid lg:grid-cols-12 lg:gap-x-12 xl:gap-x-16">
                <div className="p-2 bg-white rounded-lg lg:col-span-12 md:flex md:items-end md:justify-between md:space-x-3">
                  <div className="flex flex-col py-1 md:py-0">
                    <label
                      htmlFor="prices"
                      className="block text-sm font-semibold whitespace-nowrap text-v8-ink"
                    >
                      Price range per hour
                    </label>
                    <select
                      id="prices"
                      name="prices"
                      className="block w-full py-2 pl-2 mt-1 text-base border-v8-line rounded-md focus:border-v8-blue focus:outline-none focus:ring-v8-blue sm:text-sm"
                      // defaultValue="All Prices"
                      value={filter.prices}
                      onChange={(e) => handleChange(e)}
                    >
                      <option>All Prices</option>
                      <option>£10-£20</option>
                      <option>£20-£30</option>
                      <option>£30-£40</option>
                      <option>£40-£50</option>
                      <option>£50-£60</option>
                    </select>
                  </div>
                  <div className="flex flex-col py-1 md:py-0">
                    <label
                      htmlFor="experience"
                      className="block text-sm font-semibold text-v8-ink"
                    >
                      Tutor experience
                    </label>
                    <select
                      id="experience"
                      name="experience"
                      className="block w-full py-2 pl-2 pr-8 mt-1 text-base border-v8-line rounded-md focus:border-v8-blue focus:outline-none focus:ring-v8-blue sm:text-sm"
                      // defaultValue="All Tutor"
                      value={filter.experience}
                      onChange={(e) => handleChange(e)}
                    >
                      <option>All Experience</option>
                      <option>Head of Department Examiner</option>
                      <option>Qualified Teacher</option>
                      <option>Undergraduate Tutor</option>
                    </select>
                  </div>
                  <div className="flex flex-col py-1 md:py-0">
                    <label
                      htmlFor="gender"
                      className="block text-sm font-semibold text-v8-ink"
                    >
                      Gender
                    </label>
                    <select
                      id="gender"
                      name="gender"
                      className="block w-full py-2 pl-2 pr-8 mt-1 text-base border-v8-line rounded-md focus:border-v8-blue focus:outline-none focus:ring-v8-blue sm:text-sm"
                      // defaultValue="All Gender"
                      value={filter.gender}
                      onChange={(e) => handleChange(e)}
                    >
                      <option>All Gender</option>
                      <option>Female</option>
                      <option>Male</option>
                      <option>Other</option>
                    </select>
                  </div>
                  <div className="flex flex-col py-1 md:py-0">
                    <label
                      htmlFor="personality"
                      className="block text-sm font-semibold text-v8-ink"
                    >
                      Personality
                    </label>
                    <select
                      id="personality"
                      name="personality"
                      className="block w-full py-2 pl-2 pr-8 mt-1 text-base border-v8-line rounded-md focus:border-v8-blue focus:outline-none focus:ring-v8-blue sm:text-sm"
                      defaultValue="All Personality"
                      value={filter.personality}
                      onChange={(e) => handleChange(e)}
                    >
                      <option>All Personality</option>
                      <option>Engaging</option>
                      <option>Loud</option>
                      <option>Eccentric</option>
                      <option>Honest</option>
                      <option>Funny</option>
                      <option>Cheerleader</option>
                      <option>Interesting</option>
                      <option>Strict</option>
                    </select>
                  </div>
                  <div className="flex gap-3 flex-col-reverse">
                    {/* <CustomButton
                      className="px-12 py-2 w-fit text-sm font-semibold rounded-md"
                      variant="outlined"
                      onClick={() => clearFilter()}
                    >
                      Reset
                    </CustomButton> */}
                    <button
                      className="px-12 py-2 text-sm font-semibold text-white transition duration-300 rounded-md bg-v8-blue hover:bg-v8-blue"
                      onClick={() => handleApply()}
                    >
                      Apply
                    </button>
                  </div>
                </div>
                <div className="lg:col-span-3"></div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="min-h-full px-4 py-5 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <main className="py-10">
          <div className="mt-7 lg:grid lg:grid-cols-12 lg:items-start lg:gap-x-12 xl:gap-x-16">
            <section aria-labelledby="cart-heading" className="lg:col-span-9">
              <h2 id="cart-heading" className="sr-only">
                Tutors
              </h2>

              {!currentItems && (
                <p className="text-2xl text-v8-ink py-10 text-center border-b-2 mb-10 w-full">
                  <SvgSpinnerBlue classess={'w-10 h-10'} />
                </p>
              )}

              {currentItems && currentItems?.length === 0 && (
                <p className="text-2xl text-v8-ink py-10 text-center border-b-2 mb-10 w-full">
                  No tutor was found in that combination
                </p>
              )}

              <ul role="list" className="flex flex-col space-y-7">
                {(currentItems || []).map((product, productIdx) => (
                  <li
                    key={product?.id + productIdx}
                    className="py-1 bg-white rounded-lg"
                  >
                    <div className="flex p-2">
                      <div className="flex-shrink-0 relative w-24 h-24 rounded-md sm:h-48 sm:w-48">
                        <ImageLoader
                          alt="image"
                          fill
                          src={product?.profileImg}
                          className="object-cover object-center w-24 h-24 rounded-md sm:h-48 sm:w-48"
                          onError={dummyProfilePic}
                        />
                      </div>

                      <div className="flex flex-col w-full ml-4 sm:ml-6 md:flex-row">
                        <div className="relative flex flex-col justify-between flex-1 md:border-r border-v8-line">
                          <div className="pr-2">
                            <div>
                              <div className="flex flex-col justify-between mb-2 md:flex-row md:items-center">
                                <div>
                                  <h3 className="text-sm">
                                    <NextLink
                                      href={`/tutors/tutor-detail?tutorId=${product?.id}`}
                                      className="text-lg font-bold sm:text-xl text-v8-ink hover:text-v8-ink"
                                    >
                                      {getShortName(
                                        product?.name || product?.username,
                                      )}
                                    </NextLink>
                                  </h3>
                                </div>

                                <div className="inline-flex py-2 lg:py-0 max-w-[12rem]">
                                  {isValidUrl(product?.videoLink) && (
                                    <button
                                      type="button"
                                      onClick={() => {
                                        const YTId = isYTLink(
                                          product?.videoLink,
                                        )

                                        openModal(
                                          YTId || product?.videoLink,
                                          Boolean(YTId),
                                        )
                                      }}
                                      className="w-full rounded-md flex justify-center items-center border-2 border-v8-blue bg-[#F7F3FE] py-1 px-4 text-xs font-semibold focus:outline-none focus:ring-1 focus:ring-v8-blue focus:ring-offset-2 focus:ring-offset-v8-blue/60 hover:bg-v8-blue/5 transition duration-300"
                                    >
                                      <span className="inline-flex items-center justify-center space-x-2 text-v8-blue">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="#444CE7"
                                          viewBox="0 0 24 24"
                                          strokeWidth={1}
                                          stroke="currentColor"
                                          className="w-5 h-5"
                                        >
                                          <path
                                            stroke="#444CE7"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                          />
                                          <path
                                            stroke="white"
                                            fill="white"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z"
                                          />
                                        </svg>

                                        <span className="text-v8-blue">
                                          Introduction video
                                        </span>
                                      </span>
                                    </button>
                                  )}
                                </div>
                              </div>
                              {product?.experiences ? (
                                <div className="mb-2 text-base font-semibold text-transparent filter-button-gradient bg-clip-text">
                                  {product?.experiences}
                                </div>
                              ) : (
                                ''
                              )}
                            </div>
                          </div>

                          <div className="pr-2 mb-4 text-base text-v8-mut">
                            {product?.bio}
                          </div>
                          <div className="flex flex-col items-center py-2 pr-2 space-x-2 text-xs font-medium sm:flex-row sm:py-0">
                            <span>Subjects:</span>
                            <ul className="flex flex-wrap gap-2 ">
                              {product?.subjectsOffered &&
                                product?.subjectsOffered.map((sbj, index) => {
                                  return (
                                    <li
                                      key={index}
                                      className="py-1 px-3 text-v8-ink bg-[#F2F4F7] rounded"
                                    >
                                      {_.isString(sbj) ? sbj : ''}
                                    </li>
                                  )
                                })}
                            </ul>
                          </div>
                        </div>

                        <div className="flex flex-col justify-between md:px-4">
                          <div>
                            {product?.tutorRate?.perHourRate ? (
                              <div className="flex items-end mb-3 space-x-2 font-bold text-v8-ink">
                                <span className="text-2xl">
                                  £{product?.tutorRate?.perHourRate}
                                </span>
                                <span>/hour</span>
                              </div>
                            ) : (
                              ''
                            )}
                            {/*<div className="flex space-x-1">*/}
                            {/*  <span>*/}
                            {/*    <StarIcon className="h-5 w-5 flex-shrink-0 text-[#FDB022]" />*/}
                            {/*  </span>*/}
                            {/*  <span>*/}
                            {/*    <span className="font-medium text-v8-ink">*/}
                            {/*      {product?.avgRating}*/}
                            {/*    </span>{' '}*/}
                            {/*    <span className="text-sm font-normal text-v8-ink">*/}
                            {/*      ({product?.avgReview} reviews)*/}
                            {/*    </span>*/}
                            {/*  </span>*/}
                            {/*</div>*/}
                          </div>
                          <div>
                            <div className="relative flex items-center col-span-2 px-6 py-2 space-x-3 text-center transition duration-300 rounded-lg shadow-sm bg-v8-blue focus-within:ring-v8-violet focus-within:ring-2 focus-within:ring-offset-2 hover:bg-v8-blue">
                              <div className="flex-1 min-w-0">
                                <NextLink
                                  href={`/tutors/tutor-detail?tutorId=${product?.id}`}
                                  className="focus:outline-none"
                                >
                                  <span
                                    className="absolute inset-0"
                                    aria-hidden="true"
                                  />
                                  <p className="text-base font-semibold text-white">
                                    Book tutor
                                  </p>
                                </NextLink>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>

              <div className="w-full mt-6 lg:grid-cols-12 xl:gap-x-16">
                <div className={'col-span-9'}>
                  {pageData?.length > 0 && (
                    <Pagination
                      activePage={activePage}
                      pageCount={pageCount}
                      handlePageChange={(e) => handlePageClick(e)}
                    />
                  )}
                </div>
              </div>
            </section>

            <section
              aria-labelledby="summary-heading"
              className="mt-16 lg:mt-0 h-full lg:col-span-3 flex flex-col  lg:max-w-[178px]"
            >
              <div className="px-4 py-6 bg-white rounded-lg xs:max-w-md lg:p-4 sm:p-6">
                <div className="">
                  <Image src={girl} alt="girl img" />
                  <h2
                    id="summary-heading"
                    className="pt-3 text-xl font-bold text-v8-ink"
                  >
                    Need some <br />
                    help?
                  </h2>
                  <p className="mt-2 text-sm font-medium">
                    Our team is always available to give tips and advice{' '}
                  </p>
                  <div className="mt-6">
                    <div
                      // onClick={() => setRequestToSupport(true)}
                      onClick={() => {
                        if (user) return router.push('/student/dashboard')
                        setBookModal(true)
                      }}
                      className="w-full cursor-pointer flex justify-center items-center border-v8-blue max-w-xs lg:max-w-none border-2 rounded-md bg-[#F7F3FE] py-2 px-2 text-base font-medium  shadow-sm focus:outline-none focus:ring-1 focus:ring-v8-blue focus:ring-offset-2 focus:ring-offset-v8-blue/60"
                    >
                      <span className="flex items-center space-x-2">
                        <PhoneIcon className="flex-shrink-0 w-4 h-4 text-xs text-v8-blue" />
                        <span className="text-v8-blue">02084340644</span>
                      </span>
                    </div>
                  </div>
                  <div className="mt-6 hidden">
                    <a
                      // onClick={() => {
                      //   if (user) return router.push('/student/dashboard')
                      //   setBookModal(true)
                      // }}
                      href="tel:02084340644"
                      className="w-full cursor-pointer flex justify-center items-center border-v8-blue max-w-xs lg:max-w-none border-2 rounded-md bg-[#F7F3FE] py-2 px-2 text-base font-medium  shadow-sm focus:outline-none focus:ring-1 focus:ring-v8-blue focus:ring-offset-2 focus:ring-offset-v8-blue/60"
                    >
                      <span className="flex items-center space-x-2">
                        <PhoneIcon className="flex-shrink-0 w-4 h-4 text-xs text-v8-blue" />
                        <span className="text-v8-blue">Call for help</span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onClose={closeModal}
        cancelButton={false}
        withViselyLogo={false}
        content={
          <>
            {!selectedVideo.isYT ? (
              <video width="auto" height="240" controls autoplay loop>
                <source src={selectedVideo.videoLink} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <iframe
                className="relative z-10"
                width="100%"
                height="240"
                src={`https://www.youtube.com/embed/${selectedVideo.videoLink}`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}
          </>
        }
      />
      <Modal
        type="book"
        trigger={setSignin}
        isOpen={bookModal}
        onClose={() => setBookModal(false)}
        onConfirm={() => setBookModal(false)}
        button1Text={'Sign up 1'}
        cancelButton={false}
        title={
          <span className="inline-flex flex-col gap-3 justify-center mt-3 md:max-w-[550px]">
            <span className="text-[1.5rem]">Sign up for request callback </span>
          </span>
        }
        secondTitle={
          <span className="inline-flex mt-1">Please enter your details </span>
        }
        content={<CommonSignUpForm onClose={setBookModal} />}
      />
      <Modal
        type="signin"
        trigger={setBookModal}
        isOpen={signin}
        onClose={() => setSignin(false)}
        cancelButton={false}
        deleteButton={false}
        title={'Sign in to request a call back'}
        secondTitle={'Please enter your details.'}
        content={<SignInForm />}
      />
      <Modal
        type=""
        trigger={setRequestToSupport}
        isOpen={requstToSupport}
        onClose={() => setRequestToSupport(false)}
        onConfirm={() => setRequestToSupport(false)}
        button1Text={'Sign up 1'}
        withViselyLogo={true}
        secondTitle={
          <span className="inline-flex mt-1">Please enter your details</span>
        }
        cancelButton={false}
        content={<RequestCallback onClose={() => setRequestToSupport(false)} />}
      />
    </>
  )
}
